// extracted by mini-css-extract-plugin
export default {"wrapper":"navigator-content-module__wrapper--Dwp","header":"navigator-content-module__header--g18","subheader":"navigator-content-module__subheader--_yg"};